import { ContactResponse } from '@business/entities/contact';
import { CompactGmailMessageResponse, GmailEmailsResponse, GmailThreadId } from '@business/entities/gmail_messages';
import { OrgId } from '@business/entities/organization';
import { ContactService } from '@business/services';
import { Formatter } from '@core/utils/formatter';
import { R } from '@core/utils/r';
import React, { memo } from 'react';
import { DropdownMenu, DropdownToggle, Media, UncontrolledDropdown } from 'reactstrap';
import { openEmailOverlay } from '../TabEmail/EmailOverlay';

interface EmailFromToCardProps {
  emails: GmailEmailsResponse[];
  contacts?: ContactResponse[];
}

export const EmailFromToCard = memo((props: EmailFromToCardProps) => {
  const { emails, contacts } = props;
  return (
    <strong>
      {emails
        .map(item => {
          const contact = contacts && R.find(contacts, c => (R.find(c.emails, e => e.value === item.email) ? true : false));
          return `${contact ? contact.name : item.name} <${item.email}>`;
        })
        .join(' ')}
    </strong>
  );
});

interface EmailTimeLineItemProps {
  threadId: GmailThreadId;
  email: CompactGmailMessageResponse;
  orgId: OrgId;
  contacts: ContactResponse[];
  onReload?(): void;
  onTogglePin(id: string): void;
  isPinned: boolean;
}

export const EmailTimeLineItem = memo((props: EmailTimeLineItemProps) => {
  const { email, orgId, contacts, threadId, onTogglePin, isPinned } = props;
  return (
    <Media>
      <div className="mr-3">
        <i className={'bx ' + ContactService.getActivityIcon('email') + ' h4 text-primary'} />
      </div>
      <Media body>
        <div className="bg-light p-3">
          <div className="d-flex justify-content-between">
            <span className="text">
              <strong>{email.subject}</strong>
            </span>
            <span className="text-primary d-flex">
              {Formatter.formatTime(email.createdAt, 'LLL')}
              <a onClick={() => onTogglePin(threadId)} className="ml-2 mr-1">
                {!isPinned && <i className="bx bx-pin font-size-14"></i>}
                {!!isPinned && <i className="bx bxs-pin font-size-14"></i>}
              </a>

              <UncontrolledDropdown className="ml-2">
                <DropdownToggle tag="a" className="font-size-16 d-flex justify-content-center align-items-center text-dark">
                  <i className="bx bx-dots-horizontal-rounded"></i>
                </DropdownToggle>
                <DropdownMenu right>
                  <a
                    className="dropdown-item"
                    onClick={() => openEmailOverlay({ threadId: threadId, emailId: email.id, contacts: contacts, onClose: props.onReload })}
                  >
                    View
                  </a>
                </DropdownMenu>
              </UncontrolledDropdown>
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <span className="text-primary">
              {email.from.length > 0 && (
                <div>
                  From: <EmailFromToCard emails={email.from} contacts={contacts} />
                </div>
              )}
              {email.to.length > 0 && (
                <div>
                  To : <EmailFromToCard emails={email.to} contacts={contacts} />
                </div>
              )}
              {email.cc.length > 0 && (
                <div>
                  CC : <EmailFromToCard emails={email.cc} contacts={contacts} />
                </div>
              )}
              {email.bcc.length > 0 && (
                <div>
                  BCC : <EmailFromToCard emails={email.bcc} contacts={contacts} />
                </div>
              )}
            </span>
          </div>
          <div>{email.snippet}</div>
        </div>
      </Media>
    </Media>
  );
});
